import ApiService from './api'
import { panaceiaGenerationRequest } from './panaceiaRequests'

const base = 'modelos-pecas/rag'
const documentPath = (id) => `${base}/documentos/${encodeURIComponent(id)}`
const json = (method, body) => ({ method, body: JSON.stringify(body) })
const uploadErrorMessages = {
  413: 'O servidor bloqueou o envio pelo tamanho. A base jurídica aceita arquivos de até 10 MB. Se o arquivo estiver dentro desse limite, o limite de upload do servidor precisa ser ajustado.',
}

const PecasAcervo = {
  generationProviders: (signal) => ApiService.request(`${base}/geracao/configuracao`, { signal, cache: 'no-store' }),
  list: (filters, signal) => {
    const query = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) query.set(key, String(value))
    })
    return ApiService.request(`${base}/documentos?${query}`, { signal })
  },
  catalog: (area = '', signal) => {
    const selectedArea = area?.trim()
    const query = selectedArea ? `?${new URLSearchParams({ area: selectedArea })}` : ''
    return ApiService.request(`${base}/catalogo${query}`, { signal })
  },
  get: (id, signal) => ApiService.request(documentPath(id), { signal }),
  extract: (file, signal) => {
    const body = new FormData()
    body.append('file', file)
    return ApiService.request(`${base}/extrair-arquivo`, {
      method: 'POST', body, signal, timeoutMs: 65000, fallbackErrorMessages: uploadErrorMessages,
    })
  },
  create: (file, fields, signal) => {
    const body = new FormData()
    body.append('file', file)
    for (const key of ['titulo', 'area', 'acao', 'observacoes']) body.append(key, fields[key] || '')
    if (file.name.toLowerCase().endsWith('.pdf')) body.append('textoPdf', fields.conteudoTexto || '')
    return ApiService.request(`${base}/documentos`, {
      method: 'POST', body, signal, timeoutMs: 90000,
      fallbackErrorMessages: uploadErrorMessages,
    })
  },
  update: (id, fields, version, signal) => ApiService.request(documentPath(id), {
    ...json('PUT', { ...fields, version }), signal, timeoutMs: 60000,
  }),
  index: (id, version, signal) => ApiService.request(`${documentPath(id)}/indexar`, {
    ...json('POST', { version }), signal, timeoutMs: 350000,
  }),
  generate: (fields, signal) => ApiService.request(`${base}/gerar`, {
    ...json('POST', panaceiaGenerationRequest(fields)), signal, timeoutMs: 350000, retryOnAuthFailure: false,
  }),
  archive: (id, version, arquivar, signal) => ApiService.request(`${documentPath(id)}/arquivar`, {
    ...json('POST', { version, arquivar }), signal,
  }),
  download: (id, signal) => ApiService.request(`${documentPath(id)}/arquivo`, {
    responseType: 'blob', signal, timeoutMs: 60000,
  }),
}

export default PecasAcervo
